import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useFiles } from '~/context/files';

import { DropContainer, UploadMessage } from './styles';

interface IUploadProps {
  type: string;
  project_temp_id: string;
  project_type: string;
  sequence: number;
  user_id: string;
}

function Upload({
  type,
  project_temp_id,
  project_type,
  sequence,
  user_id,
}: IUploadProps): JSX.Element {
  const { handleUpload } = useFiles();

  const onDrop = useCallback(
    files => {
      handleUpload(
        files,
        type,
        project_temp_id,
        project_type,
        sequence,
        user_id,
      );
    },
    [handleUpload, type, project_temp_id, project_type, sequence, user_id],
  );

  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({
      accept: [
        'image/jpeg',
        'image/pjpeg',
        'image/png',
        'image/gif',
        'application/pdf',
        'audio/mp3',
        'audio/mpeg',
        'video/quicktime',
        'video/mp4',
        'text/plain',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.presentation',
        'application/vnd.oasis.opendocument.text',
      ],
      onDrop,
    });

  const renderDragMessage = useCallback(() => {
    if (!isDragActive) {
      return <UploadMessage>Arraste arquivos aqui...</UploadMessage>;
    }

    if (isDragReject) {
      return (
        <UploadMessage type="error">
          Tipo de arquivo não suportado
        </UploadMessage>
      );
    }

    return <UploadMessage type="success">Solte os arquivos aqui</UploadMessage>;
  }, [isDragActive, isDragReject]);

  return (
    <DropContainer {...getRootProps()}>
      <input {...getInputProps()} />
      {renderDragMessage()}
    </DropContainer>
  );
}

export default Upload;
